import PropTypes from 'prop-types';
import React from 'react';

export default function Initials({ name, ...props }) {
    // name is really required, but this prevents an error if it is missing.
    if (name == null) {
        name = '? ?';
    }

    const initials = name
        .split(' ')
        .map(s => s[0])
        .join('');

    return (
        <span className="initials" {...props}>
            {initials}
        </span>
    );
}

Initials.propTypes = {
    name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/initials.ui.jsx